module.exports = __webpack_public_path__ + "img/img-15.37d5cbf1.png";